var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tr", { class: { "cursor-pointer": _vm.canOpenReservation } }, [
    _c(
      "td",
      [
        _c("reservation-state-icon", {
          attrs: { state: _vm.reservation.state }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("td", [_vm._v(_vm._s(_vm.reservation.ar_external_id))]),
    _vm._v(" "),
    _c("td", [_vm._v(_vm._s(_vm.reservation.ar_created_at))]),
    _vm._v(" "),
    _c("td", [_vm._v(_vm._s(_vm.reservation.ar_acceptance_date))]),
    _vm._v(" "),
    _c("td", [_vm._v(_vm._s(_vm.reservation.installation_deadline))]),
    _vm._v(" "),
    _c("td", [_vm._v(_vm._s(_vm.reservation.ar_installation_date))]),
    _vm._v(" "),
    _c("td", [_vm._v(_vm._s(_vm.reservation.ar_current_end_date))])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-85130c10", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-85130c10","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AssetReservationManagement/Data/ReservationsTableRow.vue
// module id = null
// module chunks = 